import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgTreatmentPlanIcon(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.86 1.31v2.9h2.9v1.92h-2.9v2.9H9.94v-2.9h-2.9V4.21h2.9v-2.9h1.92ZM13.1.06H8.69v2.9h-2.9v4.41h2.9v2.9h4.41v-2.9H16V2.96h-2.9V.06ZM0 16.04h11.25v-4.22H10v2.97H1.25V1.29h4.96V.04H0v16Zm6.35-7.2H3.49v1.25h2.86V8.84Zm-2.86 2.84h5.06v1.25H3.49v-1.25Z",
    fill: "currentColor"
  }));
}

export { SvgTreatmentPlanIcon as default };
